import React from 'react'
import MyModal from './modal'


function Home(){
    return(
        <>
            <MyModal/>
        </>
    )
}
  

    
  export default Home